import React from 'react';
import '../style/navStyle.css';
import Menu from './smallComponent/Menu'

export default function Navmenu(){
    return (
           <div className="top">
            <Menu value="Home"/>
            <Menu value="About"/>
            <Menu value="Contact"/>
            <Menu value="Blog"/>
            <Menu value="Careers"/>
           </div>
    )
}